var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CalcOutputChangeRequestResponse_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ChangeRequestStatus } from './calcOutputChangeRequestEvent';
import { calcOutputChangeRequestResponseSchemaValidation } from '../validations.generated';
export const calcOutputChangeRequestResponseSchema = {
    $id: 'urn:wisepipe-common-pipe:CalcOutputChangeRequestResponse',
    type: 'object',
    properties: {
        changeRequestID: { type: 'string', uid: 9 },
        status: { type: 'string', enum: Object.values(ChangeRequestStatus) },
        calcOutputElementIDs: { type: 'array', items: { type: 'string', uid: 10 }, uniqueItems: true } // for when returning change request to UI. UI will then forward this to incentives so they know which CO tool to check.
    },
    required: ['changeRequestID', 'status']
};
let CalcOutputChangeRequestResponse = CalcOutputChangeRequestResponse_1 = class CalcOutputChangeRequestResponse {
    constructor(changeRequestID, status, calcOutputElementIDs) {
        this.changeRequestID = changeRequestID;
        this.status = status;
        if (calcOutputElementIDs !== undefined)
            this.calcOutputElementIDs = calcOutputElementIDs;
        JSON.validate(this, CalcOutputChangeRequestResponse_1);
    }
};
CalcOutputChangeRequestResponse = CalcOutputChangeRequestResponse_1 = __decorate([
    JsonSchemaV2(calcOutputChangeRequestResponseSchema, calcOutputChangeRequestResponseSchemaValidation)
], CalcOutputChangeRequestResponse);
export { CalcOutputChangeRequestResponse };
//# sourceMappingURL=calcOutputChangeRequestResponse.js.map